import { inject } from '@angular/core';
import { Router, CanActivateFn, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

export const adminGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const hostname = window.location.hostname;

  // Allow if on admin subdomain
  if (hostname.startsWith('admin.')) {
    // Access control is handled by AppComponent overlay for secret
    return true;
  }

  // Otherwise redirect to home
  return router.createUrlTree(['/']);
};
